import styled from '@emotion/styled'

export const StyleRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: calc(100vh - 210px);
  align-items: center;

  @media (max-width: 1300px) {
    height: calc(100vh - 150px);
  }
  @media (max-width: 1200px) {
    height: calc(100vh - 210px);
  }
  @media (max-width: 1024px) {
    height: calc(100vh - 210px);
  }
`

export const StyleFormWrapper = styled.div`
  width: 30%;
  height: auto;
  @media (max-width: 1300px) {
    width: 50%;
  }
  @media (max-width: 1200px) {
    width: 50%;
  }
  @media (max-width: 1024px) {
    width: 50%;
  }
  @media (max-width: 767px) {
    width: 65%;
  }
  @media (max-width: 640px) {
    width: 75%;
  }
  @media (max-width: 460px) {
    width: 100%;
  }
`
export const StyleFormTitle = styled.h1`
  font-size: 20px;
  text-align: center;
  color: ${(props: any) => props.theme.colors.primary};
  margin-bottom: 40px;
  font-weight: 700;

  span {
    color: ${(props: any) => props.theme.colors.primary};
    font-weight: 400;
  }

  @media (max-width: 1024px) {
    font-size: 22px;
  }
  @media (max-width: 640px) {
    font-size: 20px;
  }
  @media (max-width: 460px) {
    font-size: 18px;
  }
`

export const StyleFormRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  a {
    font-size: 14px;
    color: ${(props: any) => props.theme.colors.primary};
    text-decoration: none;
    margin-left: auto;
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: flex-start;
  }
  @media (max-width: 640px) {
    a {
      font-size: 13px;
    }
  }
`
export const styleBannerImage = `
  width: 100%;

  @media (max-width: 1300px) {
    width: 90%;  // Adjust width slightly for smaller screens
  }

  @media (max-width: 1200px) {
    width: 85%;  // Decrease width further
  }

  @media (max-width: 1024px) {
  display :none;
  }

  @media (max-width: 767px) {
  display :none;
  }

  @media (max-width: 640px) {
  display :none;
  }

  @media (max-width: 460px) {
  display :none;
  }

  @media (max-width: 360px) {
  display :none;
  }
`
export const styleCard = `
  padding: 30px 40px;
  height:60%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  form {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  @media (max-width: 1300px) {
  height:50%;
  }

  @media (max-width: 1200px) {
    height: auto; // Allow the height to adjust dynamically
    padding: 25px; // Reduce padding for smaller screens
  }

  @media (max-width: 1024px) {
    height: auto;
    padding: 20px; // Further reduce padding
  }

  @media (max-width: 767px) {
    padding: 15px; // Even smaller padding
  }

  @media (max-width: 640px) {
    padding: 10px; // Minimal padding for mobile
  }

  @media (max-width: 460px) {
    padding: 8px; // Smallest padding for very small devices
  }

  @media (max-width: 360px) {
    padding: 5px; // Minimize padding for extra small screens
  }
`
